import { render, staticRenderFns } from "./ProfileTableItemValueDate.vue?vue&type=template&id=09dc9fe3&scoped=true&"
import script from "./ProfileTableItemValueDate.vue?vue&type=script&lang=ts&"
export * from "./ProfileTableItemValueDate.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileTableItemValueDate.vue?vue&type=style&index=0&id=09dc9fe3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dc9fe3",
  null
  
)

export default component.exports